export const setStringToUpper = (param: string) => {
   return param.toUpperCase()
}
